import type {StepDefinition, StepHideRule} from '~/models/wizardSchema'
import type {StepEntity} from '~/helpers/wizardSteps'

export const hasSilvicultureActionPlans = (contract: StepEntity | undefined): boolean =>
    contract?.AllmaJobs?.some(job => job.Actions?.some(action => (action.SilviCultureActionPlans?.length ?? 0) > 0)) ?? false

export const noSilviculturePlans: StepHideRule<StepEntity | undefined> = {
    id: 'noSilviculturePlans',
    isHidden: (draft) => !hasSilvicultureActionPlans(draft),
}

export const isStepVisible = (step: StepDefinition, draft: StepEntity | undefined): boolean =>
    !(step.hiddenWhen ?? []).some((rule) => rule.isHidden(draft))
